/**
 * ATT-2872 admin half — tenant discovery module.
 *
 * Boot-time identity + routing hydration. ATT-3383: tenant resolution is
 * registry-only, so discovery fires for EVERY host (no CSV allowlist gate, no
 * static tenant map).
 *
 * Cross-reference: `lib/tenantSettings/` is the parallel ATT-2871 overlay
 * (post-boot, 2 keys, for hosts with `useBackendSettings: true`). The two
 * modules intentionally share only the shared core fetcher
 * (`lib/tenantSettings/fetch.ts`); other concerns (Zod allowlist, store, hook)
 * are disjoint by design (pre-mortem risk #9).
 */

export { useTenantDiscovery } from "./useTenantDiscovery";
export type { TenantDiscoveryView } from "./useTenantDiscovery";
export { useTenantDiscoveryStore } from "./store";
export type { TenantDiscoverySource, TenantDiscoveryState } from "./store";
